import * as React from 'react'
import {useLocation} from 'react-router-dom'

import {useAppSelector} from '../../../hooks/react-redux'
import type {State} from '../../../reducers/types'
import {HTTPCodesEnum} from '../../../rest/errors/HTTPError'
import {getAvailabilityResponse} from '../../App/App.selectors'
import ErrorPage from '../ErrorPage/ErrorPage'

export type ErrorType = {
  statusCode?: number
  message?: string
}

interface Props {
  getErrorMessage?: ((arg0: ErrorType) => string | null | undefined) | null | undefined
  onRetry?: (() => unknown) | null | undefined
  children: React.ReactNode
}

export function AvailabilityErrorPage(props: Props) {
  const {getErrorMessage, onRetry} = props
  const location = useLocation()
  const availabilityResponse = useAppSelector((state: State) =>
    getAvailabilityResponse(state, location.pathname),
  )

  if (availabilityResponse != null && availabilityResponse.statusCode !== HTTPCodesEnum.OK) {
    const errorMessage = getErrorMessage != null ? getErrorMessage(availabilityResponse) : ''
    return (
      <ErrorPage
        error={errorMessage != null ? errorMessage : availabilityResponse.message}
        notFound={availabilityResponse.statusCode === HTTPCodesEnum.NOT_FOUND}
        onRetry={onRetry}
      />
    )
  }

  return <>{props.children}</>
}
